const apiRoot = process.env.REACT_APP_API_URL || 'http://localhost:3010';

const globals = {
  api_url: apiRoot,
  api_root: apiRoot,
  upload_root: apiRoot,
};

export default globals;
